export enum TAB_ROUTES {
    DETAILS = 'details',
    CODE = 'code',
    DASHBOARD = 'dashboard',
    JOBS = 'jobs',
    APPROVALS = 'approvals',
    CHANGE_HISTORY = 'change-history',
    PRODUCT_CONFIG = 'product-config',
    INVOCATION_SCENARIO = 'invocation',
    TRANSFORMS = 'transforms',
    JOB = 'job',
    SIMULATION = 'simulations',
    DASHBOARD_REGISTRY = 'dashboard-registry',
    SCRIPTS = 'scripts',
    INTEGRATIONS = 'integrations',
    COST_CONFIGS = 'cost-configs',
    // NOTE: /profile/my-account is hardcoded in ggx-sdk. Update there if changing here
    MY_ACCOUNT = 'my-account',
    OVERVIEW = 'overview',
    RISK_ASSESSMENT = 'risk-assessment',
    CHAT_SESSION = 'chat-session',
    SETTINGS = 'settings',
    INSIGHTS = 'insights',
    DATA_PREVIEW = 'data-preview',
    LOGS = 'logs',
    SINGLE = 'single',
}
